<script setup lang="ts" name="AdminSailingScheduleRecipientListNewSuccess">
import { computed } from 'vue';

import { FREQUENCY_TYPE, FREQUENCY_TYPE_TO_SUCCESS_MESSAGE } from '~/constants';

import { getDateYear } from '~/features/useDates';

import SuccessCard from '~/components/SuccessCard.vue';

const { frequency } = defineProps<{
  frequency: string;
  recipients: string[];
  startRecurringDate: string;
}>();

const successTitle = computed(() =>
  frequency === FREQUENCY_TYPE.ONCE
    ? 'Sailing Schedule Shared Successfully!'
    : 'Sailing Schedule Is Set Up for Sharing!',
);
</script>

<template>
  <SuccessCard
    button-text="See Recipient List"
    :path="{ name: 'AdminScheduleRecipientList' }"
    :title="successTitle"
  >
    <template #message>
      <p
        v-if="frequency === FREQUENCY_TYPE.ONCE"
        class="mx-2 my-4 text-center text-primary-8"
      >
        You have successfully shared the sailing schedule with
        <b>{{ recipients.length }}</b> recipient (-s). Recipient (-s) will
        receive email on <b>{{ getDateYear(startRecurringDate) }}</b
        >.
      </p>

      <p v-else class="mx-2 my-4 text-center text-primary-8">
        You have successfully created the sailing schedule sharing list for
        <b>{{ recipients.length }}</b> recipient (-s). Recipient (-s) will
        receive recurring emails on a
        <b>{{ FREQUENCY_TYPE_TO_SUCCESS_MESSAGE[frequency] }}</b> basis,
        starting on
        <b
          ><span class="whitespace-nowrap">{{
            getDateYear(startRecurringDate)
          }}</span></b
        >.
      </p>
    </template>
  </SuccessCard>
</template>
